import React, {useCallback, useEffect, useState} from 'react';

import {ItemsType, Scrollbar} from '@veneer/core';

import {AppHeader as MGAppHeader} from '@br/mg-components';

import {useMediaQuery} from '../../hooks/useBreakpoints';
import {ActionsProps} from '../AppHeader/components/Actions/types';
import {NavProps, SideMenu, SideMenuToggleCallback} from '../SideMenu';
import {AppSwitcherProps} from '../WFCAppSwitcher';
import {UserInfo} from '../src/UserMenu/types';

import useStyle from './styles';

const BasicPage = ({
    children,
    nav,
    sideMenuDefaultPinned,
    sideMenuOnToggle,
    padContent = true,
    actions,
    environment,
    disableAppSwitcher,
    userInfo,
    headerActions,
    breadcrumbs,
    loginType,
}: {
    headerActions?: React.ReactNode;
    userInfo?: UserInfo | null;
    breadcrumbs?: ItemsType[];
    actions: ActionsProps;
    children: React.ReactNode;
    nav?: React.JSXElementConstructor<NavProps>;
    sideMenuDefaultPinned?: boolean;
    sideMenuOnToggle?: SideMenuToggleCallback;
    padContent?: boolean;
    environment: AppSwitcherProps['environment'];
    disableAppSwitcher: AppSwitcherProps['disableAppSwitcher'];
    loginType: AppSwitcherProps['loginType'];
}) => {
    const style = useStyle(padContent);
    const isLgScreen = useMediaQuery('lg');
    const [sideMenuVisible, setSideMenuVisible] = useState(false);

    const toggleSideMenu = useCallback(() => {
        setSideMenuVisible(curr => !curr);
    }, []);

    useEffect(() => {
        setSideMenuVisible(false);
    }, [isLgScreen]);

    return (
        <div className={style.pageLayout}>
            <div>
                <MGAppHeader
                    loginType={loginType}
                    hasSideMenu={!!nav}
                    toggleSideMenu={toggleSideMenu}
                    actions={actions}
                    environment={environment}
                    disableAppSwitcher={disableAppSwitcher}
                    userInfo={userInfo}
                    headerActions={headerActions}
                    breadcrumbs={breadcrumbs}
                />
            </div>
            <div className={style.layout}>
                <div className={style.navWrapper}>
                    {nav && (
                        // eslint-disable-next-line @br/idm/veneer-require-i18n-attribute
                        <SideMenu
                            controlledState={sideMenuVisible}
                            nav={nav}
                            onToggle={sideMenuOnToggle}
                            defaultPinned={sideMenuDefaultPinned}
                        />
                    )}
                </div>

                <div className={style.contentStyles}>
                    <Scrollbar
                        data-testid="content-container"
                        tabIndex="-1"
                        className={style.scrollbar}
                    >
                        {children}
                    </Scrollbar>
                </div>
            </div>
        </div>
    );
};

export default BasicPage;
